/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-30 12:12:40
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-11 14:57:45
 * @FilePath: /portal2/unifyxp-v2-store-portal/src/pages/ProductEditor/slice/constants.ts
 */
export enum EnumReducers {
  virtualProduct = 'virtualProduct',
}
